import { FC, useEffect, useState } from 'react';
import { NudosGenericModal, NudosModalContent, NudosButton, NudosUploadDownloadButton } from '../../../NudosComponents';
import {
  CONFIG_FIELD_NAME_TO_ID,
  TConfigFieldNameToId,
  IConfigClass
} from '../../../../constants/configurations.constants';
import { IData } from '../../../../types/orders';
import { getConfigFieldDisplayName } from '../../../../utils/configurations';
import { CONFIG_FIELD_NAME_ID } from '../../../../types/product.configuration.types';

import './SettingsModal.scss';

interface ISettingsModal {
  closeModal: () => void;
  textDetails: string;
  isConfiguration?: boolean;
  configClass: IConfigClass | null;
  configData: IData[] | null;
}
const SettingsModal: FC<ISettingsModal> = ({
  closeModal,
  textDetails,
  isConfiguration,
  configClass,
  configData
}: ISettingsModal) => {
  const [listableFields, setListableFields] = useState<IData[]>(configData || []);
  const [fieldFileUrl, setFieldFileUrl] = useState<IData | null>(null);

  const isFieldFileUrl = (fieldName: string) => {
    return CONFIG_FIELD_NAME_TO_ID[fieldName as TConfigFieldNameToId] === CONFIG_FIELD_NAME_ID.FILE_URL;
  };

  const isFieldComment = (fieldName: string) => {
    return CONFIG_FIELD_NAME_TO_ID[fieldName as TConfigFieldNameToId] === CONFIG_FIELD_NAME_ID.COMMENTS;
  };

  const getCommentsType = () => {
    if (isConfiguration) {
      const isUniqueComment = listableFields.length === 1 && listableFields.find(item => isFieldComment(item.name));
      if (isUniqueComment) {
        return <div className="grayDetailsSetting">{listableFields[0].value}</div>;
      }

      return (
        <div className="grayDetailsSetting">
          <ul className="listStyle">
            {listableFields.map(item => {
              return (
                <li key={item.name}>
                  <span className="titleList">{getConfigFieldDisplayName(configClass?.id, item.name)}: </span>
                  {item.value}
                </li>
              );
            })}
          </ul>
        </div>
      );
    }
    return <div className="grayDetailsSetting">{textDetails}</div>;
  };

  useEffect(() => {
    const listableFields = configData?.filter(item => !isFieldFileUrl(item.name));
    setListableFields(listableFields || []);
  }, [configData]);

  useEffect(() => {
    const fieldFileUrl = configData?.find(item => isFieldFileUrl(item.name));
    setFieldFileUrl(fieldFileUrl || null);
  }, [configData]);

  return (
    <NudosGenericModal
      closeModalCallback={closeModal}
      modalContent={
        <NudosModalContent
          toCloseModal={closeModal}
          noScroll
          startHeader
          customHeaderClass="pl-10"
          customHeight="446px"
          customWidth="580px"
          modalContentTitle="Configuraciones"
          CustomModalComponent={
            <div id="settingsModal">
              <div className="boxSettingsModal">
                <div className="settingsModalTitle">
                  Consulta los detalles de la configuración solicitada para esta herramienta.
                </div>
                {isConfiguration && (
                  <div className="settingsType">
                    <div className="settingsTypeTitle">Tipo de configuración</div>
                    <div className="settingsTypeValue">{configClass?.name}</div>
                  </div>
                )}
                <div className="detailsText">
                  <div className="grayBoxDetails">
                    <div className="grayTitleSettings">Detalles de la configuración</div>
                    <div className="grayDetailsSetting">{getCommentsType()}</div>
                  </div>
                </div>
                {isConfiguration && fieldFileUrl && (
                  <NudosUploadDownloadButton
                    customClassName="fileUploadButton"
                    currentFileUrl={fieldFileUrl.value}
                    buttonEmptyText="Descargar archivo"
                    buttonFilledText="PDF o JPG"
                    downloadButtonText="Descargar archivo"
                    isDisabled={false}
                    customWidth="480px"
                    customHeight="30px"
                    uploadedFileHandler={() => {}}
                  />
                )}
                <div className="buttonCloseContainer">
                  <NudosButton buttonText="Cerrar" customHeight="38px" handleClick={closeModal} customWidth="180px" />
                </div>
              </div>
            </div>
          }
        />
      }
    />
  );
};
export default SettingsModal;
